import React, { useState, useEffect } from 'react'
import { Box, Select, Flex, Group, Button, Avatar, Text, NumberInput } from '@mantine/core'
import { validation } from '../../../../../plugins/validation'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrder } from '../../../../../services/orders'
import { getListUsers } from '../../../../../services/users'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { IconCheck } from '@tabler/icons-react'

const defaultVal = {
  ordered_by_user_id: '',
  pending_commision: 0
}

const formValidation = {
  pending_commision: {
    isError: false,
    message: ''
  }
}

const FormAdjustAgent = ({ onCloseForm }) => {
  const { summary } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)
  const [userList, setUserList] = useState([])
  const [searchAgent, setSearchAgent] = useState('')

  const submitAgent = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)

    if (formData.ordered_by_user_id !== null) {
      const validateValue = {
        pending_commision: form.pending_commision.toString()
      }
      const isError = validation(validateValue, setValidationForm)
      if (isError) {
        setLoadingForm(false)
        return
      }
    }

    const payload = {
      ordered_by_user_id: form.ordered_by_user_id !== null ? Number(form.ordered_by_user_id) : null,
      pending_commision: form.ordered_by_user_id !== null ? form.pending_commision : 0
    }
    try {
      const response = await updateOrder(orderId, payload)
      if (response.success) {
        onCloseForm()
        dispatch(getOrderDetail(orderId))
        notificationSuccess('Update Order Successfully', 'This data has been updated')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetListUsers = async (userId) => {
    const parameter = {
      'filter[id][is]': userId,
      'filter[name][like]': searchAgent,
      'fields[user]': 'id,name,email',
      'page[num]': 1,
      'page[limit]': 8,
      'sort': '-created_at',
      'filter[is_agent][is]': 1
    }
    try {
      const response = await getListUsers(parameter)
      const dataUser = response.data.data
      const remapDataUser = dataUser.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`,
          email: val.attributes.email
        }
      })
      setUserList(remapDataUser)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    handleGetListUsers()
    // eslint-disable-next-line
  }, [searchAgent])

  useEffect(() => {
    if (summary) {
      handleGetListUsers(summary.agentId)
      handleSetForm(summary)
    }
    // eslint-disable-next-line
  }, [summary])

  const handleSetForm = (value) => {
    const dataDetail = {
      ordered_by_user_id: value.agentId !== null ? `${value.agentId}` : null,
      pending_commision: value.agentCommision
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const renderUserOption = ({ option, checked }) => {
    return (
      <Group flex="1" align='center' gap="xs">
        <Flex gap='sm' align='center'>
          <Avatar variant='filled' name={option.label} radius="xl" size="sm" color='red' />
          <Box>
            <Text fz={12} fw='600' lineClamp={2}>{option.label}</Text>
            <Text fz={10} fw='500' c='gray.6' lineClamp={2}>{option.email}</Text>
          </Box>
        </Flex>
        {checked && <IconCheck style={{ marginInlineStart: 'auto' }} />}
      </Group>
    )
  }

  return (
    <Box>
      <Box mb='md'>
        <Select
          name='ordered_by_user_id'
          value={formData.ordered_by_user_id}
          label='Agent'
          placeholder='Select Agent'
          data={userList}
          renderOption={renderUserOption}
          onChange={(val) => handleChangeForm('ordered_by_user_id', val)}
          size='xs'
          searchable
          searchValue={searchAgent}
          onSearchChange={setSearchAgent}
          nothingFoundMessage="No Agent Found"
          clearable
        />
      </Box>
      <Box mb='md'>
        <NumberInput
          name='pending_commision'
          value={formData.pending_commision}
          label="Commision Amount"
          placeholder="Input commision amount"
          onChange={(val) => handleChangeForm('pending_commision', val)}
          error={validationForm.pending_commision.isError ? `${validationForm.pending_commision.message}` : ''}
          size='xs'
          withAsterisk
          disabled={formData.ordered_by_user_id === null}
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitAgent(formData)}>Update</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustAgent